import "../styles/news.css"


function News() {
	return (
	  <div className="news">
	    <div className="news-title">
	      <h1>News</h1>
	    </div>
	    <div className="news-links">
	      <p style={{ color: "black" }}>Sonal was a Hackathon Organizer with <a href="https://wic.ucsd.edu/" target="_blank" rel="noreferrer">UCSD's Women In Computing</a> to create an environment that spurred news ideas in <a href="https://hacknightii.devpost.com/project-gallery" target="_blank" rel="noreferrer">tech for good.</a></p>
	    </div>
	    <div className="news-links">
	      <p style={{ color: "black" }}>Sonal was an Event Organizer as the Vice President of <a href="https://tedxgunnhighschool.com/" target="_blank" rel="noreferrer">TEDxGunnHighSchool</a> that <a href="https://www6.slac.stanford.edu/news/2011-07-14-tedx-talk-slac-scientist-shares-idea-worth-spreading" target="_blank" rel="noreferrer">presents people's work and fascinating ideas.</a></p>
	    </div>
	    <div className="news-links">
	      <p style={{ color: "black" }}>Sonal participated in the Gunn High School's Robotics team and in the <a href="https://gunnoracle.com/2106/news/robotics-team-competes-in-regionals/" target="_blank" rel="noreferrer">FIRST Competition.</a></p>
	    </div>
	  </div>
	);
}

export default News;